import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-money\"><defs><style type=\"text/css\"></style></defs><path d=\"M497.28 1020.672c-273.92 0-496-222.08-496-496 0-273.92 222.08-496 496-496 273.952 0 496 222.08 496 496 0 273.92-222.048 496-496 496z m0-64c238.624 0 432-193.408 432-432s-193.376-432-432-432c-238.56 0-432 193.408-432 432s193.44 432 432 432zM265.28 306.944h91.264l140.768 161.984 142.272-161.984h89.728l-156.544 177.6h106.752v58.944h-139.936l-0.8 0.768v64.96h140.736v60.928h-140.736v100.8H455.68v-100.8H315.872v-60.928h139.84v-64.96l-0.832-0.768H315.872v-58.944h105.984L265.28 306.944z\" fill=\"#FF3399\" p-id=\"3555\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"icon-[name]"}!./src/assets/icons/svg/money.svg
// module id = n+01
// module chunks = 1